import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { Globals } from '../../globals';
import { DownloadAssessmentManager } from '../../services/angular/DownloadAssessmentManager';
import 'chartjs-plugin-datalabels';
import { ClientsService } from 'app/services/client/ClientsService';
import { AssessmentsService } from 'app/services/assessment/AssessmentsService';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
// import { setTimeout } from 'timers';

@Component({
  selector: 'app-assessment-report',
  templateUrl: './assessment-report.component.html',
  styleUrls: ['./assessment-report.component.scss'],
  providers: [DownloadAssessmentManager]
})
export class AssessmentReportComponent implements OnInit {

    //Graphic1
    ERGraphicDatasets: any[] = [];
    ERGraphicLabel: string[] = [];
    ERGraphicOptions: any = {
        scaleShowVerticalLines: true,
        responsive: true,
        scales: {
            xAxes: [{
                display: false,
                ticks: {
                    beginAtZero: true,
                    //max: 100
                }
            }],
        },
        tooltips: {
            displayColors: false,
            titleSpacing: 0,
            titleMarginBottom: 0,
            xPadding: 5,
            yPadding: 2,
            callbacks: {
                label: (tooltipItem, data) => {
                    console.log("tooltipItem", tooltipItem);

                    var level = this.getLevelByIndex(tooltipItem);
                    return `Level ${level}: ${tooltipItem.xLabel}%`;
                }
            }
        },
        hover: {
            animationDuration: 5
        },
        plugins: {
            datalabels: {
                display: false
            }
        }
    };

    ERGraphicLegend: boolean = false;
    ERGraphicChartType: string = 'horizontalBar';

    colors: Array<any> = [
        { // blue
            backgroundColor: "#1588eb",
            borderColor: "rgba(0,192,192,1)",
            pointBorderColor: "rgba(0,181,255,1)",
            pointBackgroundColor: "rgba(255,255,255,1)",
            pointBorderWidth: 1,
        }
    ];

    //Graphic2
    ERPGraphicDatasets: any[] = [];
    ERPGraphicLabel: string[] = [];
    ERPGraphicOptions: any = {
        scaleShowVerticalLines: false,
        responsive: true,
        scales: {
            xAxes: [{
                display: false,
                ticks: {
                    display: false,
                    beginAtZero: true,
                    //max: 100
                }
            }]
        },
        plugins: {
            datalabels: {
                display: false
            }
        },
        tooltips: {
            displayColors: false,
            titleSpacing: 0,
            titleMarginBottom: 0,
            xPadding: 5,
            yPadding: 2,
            callbacks: {
                label: (tooltipItem, data) => {
                    console.log("tooltipItem", tooltipItem);

                    var level = this.getLevelByIndex(tooltipItem);
                    return `Level ${level}: ${tooltipItem.xLabel}%`;
                }
            }
        }
    };
    ERPGraphicLegend: boolean = false;
    ERPGraphicChartType: string = 'horizontalBar';

    ARL: any;
    EP: any;
    ESR: any;

    loadingMessage: string = "Loading Asessment, please wait...";
    graphicTitle1: string = '';
    graphicTitle2: string = '';

    assignmentId: number;
    completedOn: string;
    client: string;
    niche: string;
    finish: boolean = false;

    levels1: any[] = [];
    levels2: any[] = [];
    assessmentAnswers: any[] = [];
    loading: boolean = true;

    questions360_1: any[] = [];

    questions360_2: any[] = [];


    //360 Graphic1.1
    //graphic360_1_1_Datasets: any[] = [{
    //    data: [4, 3.5, 4, 4.6, 3.5]
    //}];
    //graphic360_1_1_Label: string[] = ["Self", "Direct report", "Peer", "Client", "Vendor"];
    /*360 graphics*/
    graphic360_1_1_Options: any = {
        scaleShowVerticalLines: true,
        responsive: true,
        scales: {
            xAxes: [{
                display: true,
                ticks: {
                    beginAtZero: true,
                    max: 5
                }
            }],
        },
        tooltips: {
            enabled: true
        },
        hover: {
            animationDuration: 5
        },
        plugins: {
            datalabels: {
                anchor: 'end',
                align: 'end',
                offset : -20,
                color: '#fff',
                font: {
                    weight: 'bold'
                }
            }
        }
    };

    graphic360_1_1_Legend: boolean = false;
    graphic360_1_1_ChartType: string = 'horizontalBar';

    colors360: Array<any> = [
        { // blue
            backgroundColor: [
                '#4f81bd',
                '#c0504d',
                '#9bbb59',
                '#8064a2',
                '#4bacc6',
                '#4FBD8C',
                '#571485',
                '#4F671D',
                '#484937',
                '#135364'
            ],
            borderColor: [
                '#4f81bd',
                '#c0504d',
                '#9bbb59',
                '#8064a2',
                '#4bacc6',
                '#4FBD8C',
                '#571485',
                '#4F671D',
                '#484937',
                '#135364'
            ],
            pointBorderColor: "rgba(0,181,255,1)",
            pointBackgroundColor: "rgba(255,255,255,1)",
            pointBorderWidth: 1,
        }
    ];
    show360Section: boolean = true;
    assessmentName: string = "";
    assessmentId: number;
    content: any;
    language: string;

    //360 Graphic1.2
    //graphic360_1_2_Datasets: any[] = [{
    //    label: '',
    //    data: [5, 3.5, 4, 4.8, 4.5]
    //}];
    //graphic360_1_2_Label: string[] = ["Self", "Direct report", "Peer", "Client", "Vendor"];
    //graphic360_1_2_Options: any = {
    //    scaleShowVerticalLines: true,
    //    responsive: true,
    //    scales: {
    //        xAxes: [{
    //            display: true,
    //            ticks: {
    //                beginAtZero: true,
    //                max: 5
    //            }
    //        }],
    //    },
    //    tooltips: {
    //        enabled: true
    //    },
    //    hover: {
    //        animationDuration: 5
    //    },
    //    plugins: {
    //        datalabels: {
    //            anchor: 'end',
    //            align: 'end',
    //            color: '#000000',
    //            font: {
    //                weight: 'bold'
    //            }
    //        }
    //    }
    //};

    //graphic360_1_2_Legend: boolean = false;
    //graphic360_1_2_ChartType: string = 'horizontalBar';

    //360 Graphic1.3
    //graphic360_1_3_Datasets: any[] = [{
    //    label: '',
    //    data: [3, 3.5, 4.5, 4.2, 3.5]
    //}];
    //graphic360_1_3_Label: string[] = ["Self", "Direct report", "Peer", "Client", "Vendor"];
    //graphic360_1_3_Options: any = {
    //    scaleShowVerticalLines: true,
    //    responsive: true,
    //    scales: {
    //        xAxes: [{
    //            display: true,
    //            ticks: {
    //                beginAtZero: true,
    //                max: 5
    //            }
    //        }],
    //    },
    //    tooltips: {
    //        enabled: true
    //    },
    //    hover: {
    //        animationDuration: 5
    //    },
    //    plugins: {
    //        datalabels: {
    //            anchor: 'end',
    //            align: 'end',
    //            color: '#000000',
    //            font: {
    //                weight: 'bold'
    //            }
    //        }
    //    }
    //};

    //graphic360_1_3_Legend: boolean = false;
    //graphic360_1_3_ChartType: string = 'horizontalBar';

    //360 Graphic2.1
    //graphic360_2_1_Datasets: any[] = [{
    //    label: '',
    //    data: [4, 3.5, 4.5, 4.6, 4.5]
    //}];
    //graphic360_2_1_Label: string[] = ["Self", "Direct report", "Peer", "Client", "Vendor"];
    //graphic360_2_1_Options: any = {
    //    scaleShowVerticalLines: true,
    //    responsive: true,
    //    scales: {
    //        xAxes: [{
    //            display: true,
    //            ticks: {
    //                beginAtZero: true,
    //                max: 5
    //            }
    //        }],
    //    },
    //    tooltips: {
    //        enabled: true
    //    },
    //    hover: {
    //        animationDuration: 5
    //    },
    //    plugins: {
    //        datalabels: {
    //            anchor: 'end',
    //            align: 'end',
    //            color: '#000000',
    //            font: {
    //                weight: 'bold'
    //            }
    //        }
    //    }
    //};

    //graphic360_2_1_Legend: boolean = false;
    //graphic360_2_1_ChartType: string = 'horizontalBar';
    

    //360 Graphic2.2
    //graphic360_2_2_Datasets: any[] = [{
    //    label: '',
    //    data: [3, 3, 3, 4.4, 4]
    //}];
    //graphic360_2_2_Label: string[] = ["Self", "Direct report", "Peer", "Client", "Vendor"];
    //graphic360_2_2_Options: any = {
    //    scaleShowVerticalLines: true,
    //    responsive: true,
    //    scales: {
    //        xAxes: [{
    //            display: true,
    //            ticks: {
    //                beginAtZero: true,
    //                max: 5
    //            }
    //        }],
    //    },
    //    tooltips: {
    //        enabled: true
    //    },
    //    hover: {
    //        animationDuration: 5
    //    },
    //    plugins: {
    //        datalabels: {
    //            anchor: 'end',
    //            align: 'end',
    //            color: '#000000',
    //            font: {
    //                weight: 'bold'
    //            }
    //        }
    //    }
    //};

    //graphic360_2_2_Legend: boolean = false;
    //graphic360_2_2_ChartType: string = 'horizontalBar';

    IsMODIII: boolean = false;
    progressRef: NgProgressRef;

    constructor(
        private activatedRoute: ActivatedRoute,
        private _ClientsService: ClientsService,
        private _Globals: Globals,
        private _DownloadAssessmentManager: DownloadAssessmentManager,
        private _AssessmentsService: AssessmentsService,
        private _Router: Router,
        public ngProgress: NgProgress
    ) {
        this.activatedRoute.params.subscribe(params => {
            console.log(params['assignmentId']);
            this.assignmentId = params['assignmentId'];
        });
    }

    ngOnInit() {
        this.GetCompletedAssessmentDetails();
        this.progressRef = this.ngProgress.ref();
    }

    getLevelByIndex(tooltipItem): number {

        var currentLevel: number;

        switch (tooltipItem.index) {
            case 0:
                return currentLevel = 7;
            case 1:
                return currentLevel = 6;
            case 2:
                return currentLevel = 5
            case 3:
                return currentLevel = 4;
            case 4:
                return currentLevel = 3;
            case 5:
                return currentLevel = 2;
            case 6:
                return currentLevel = 1;
        }
    }


    tabSelect(event) {
        console.log(event);
        if (event == 1) {
            setTimeout(() => {
                this.hideLevel('level1');
                this.hideLevel('level2');
                this.hideLevel('level3');
                this.hideLevel('level4');
                this.hideLevel('level5');
                this.hideLevel('level6');
                this.hideLevel('level7');
            }, 50);

        }
    }

    hideLevel(level: string) {
        $('.' + level).hide();
        $('.answerLevels .' + level).hide();
        $('.answerLevels .' + level).eq(0).show();
    }

    back() {
        window.history.back();
    }

    downloadAssessment() {
        this.finish = false;
        setTimeout(() => {
            $('#loadingText').text('Downloading report...');
        }, 100)
        this.progressRef.start();
        this._Globals.loadPageContentClientResults = true;
        this._DownloadAssessmentManager.downloadReport(this._Globals.getUserId(), this.assignmentId, 3, this);
    }

    GetCompletedAssessmentDetails() {
        this._ClientsService.getCompletedAssessmentDetails(this.assignmentId).subscribe(data => {
            console.log('response_GetCompletedAssessmentDetails', data.result);
            this.completedOn = data.result.CompletedOn;
            this.client = data.result.ClientFirstName + " " + data.result.ClientLastName;
            this.niche = data.result.Niche;
            this.assessmentAnswers = data.result.AssessmentAnswers;
            this.assessmentName = data.result.AssessmentName;
            this.assessmentId = data.result.AssessmentId;
            this.language = data.result.Language;
            this.getAssessmentPageByUserType();
            this.IsMODIII = data.result.IsMODIII;

            if (this._Globals.getUserId() !== data.result.ClientId) {
                console.log('coachResultsDisplayToast');
                this._Globals.coachResultsDisplayToast = true;
                this._Router.navigate(['/app/client_assessments']);
            }

            data.result.AssessmentResults.forEach((x) => {
                switch (x.Id) {
                    case 1: {
                        this.ARL = x;
                        break;
                    }
                    case 2: {
                        this.EP = x;
                        this.graphicTitle1 = x.Name;
                        break;
                    }
                    case 3: {
                        this.ESR = x;
                        this.graphicTitle2 = x.Name;
                        break;
                    }
                }
            });

            /*let questions360_1 = {
                "questions": [
                    {
                        "text": "adapt to change",
                        "values": [
                            {
                                "text": "Self",
                                "value": 4
                            },
                            {
                                "text": "Direct report",
                                "value": 3.5
                            },
                            {
                                "text": "Peer",
                                "value": 4
                            },
                            {
                                "text": "Client",
                                "value": 4.6
                            },
                            {
                                "text": "Vendor",
                                "value": 3.5
                            }
                        ]
                    },
                    {
                        "text": "digest new information quickly, and adjust course appropriately",
                        "values": [
                            {
                                "text": "Self",
                                "value": 5
                            },
                            {
                                "text": "Direct report",
                                "value": 3.5
                            },
                            {
                                "text": "Peer",
                                "value": 4
                            },
                            {
                                "text": "Client",
                                "value": 4.8
                            },
                            {
                                "text": "Vendor",
                                "value": 4.5
                            }
                        ]
                    },
                    {
                        "text": "suppor other's development",
                        "values": [
                            {
                                "text": "Self",
                                "value": 3
                            },
                            {
                                "text": "Direct report",
                                "value": 3.5
                            },
                            {
                                "text": "Peer",
                                "value": 4.5
                            },
                            {
                                "text": "Client",
                                "value": 4.2
                            },
                            {
                                "text": "Vendor",
                                "value": 3.5
                            }
                        ]
                    },
                    {
                        "text": "facilitate effective meetings",
                        "values": [
                            {
                                "text": "Self",
                                "value": 4
                            },
                            {
                                "text": "Direct report",
                                "value": 3.5
                            },
                            {
                                "text": "Peer",
                                "value": 4.5
                            },
                            {
                                "text": "Client",
                                "value": 4.6
                            },
                            {
                                "text": "Vendor",
                                "value": 4.5
                            }
                        ]
                    },
                    {
                        "text": "effectively handle conflict",
                        "values": [
                            {
                                "text": "Self",
                                "value": 3
                            },
                            {
                                "text": "Direct report",
                                "value": 3
                            },
                            {
                                "text": "Peer",
                                "value": 3
                            },
                            {
                                "text": "Client",
                                "value": 4.4
                            },
                            {
                                "text": "Vendor",
                                "value": 4
                            }
                        ]
                    }
                ]
            }*/
            let questions360_1 = data.result.Section1_360;
            let questions360_2 = data.result.Section2_360;

            console.log("questions pre formated", questions360_1);

            //this.questions360_2 = {
            //    "questions": [
                    
            //    ]
            //}
            //console.log("questions 360 2", this.questions360_2);
            
            this.questions360_1 = this.retriveChartData(questions360_1);
            this.questions360_2 = this.retriveChartData(questions360_2);
            //this.questions360_1 = Object.keys(rData).map(i => rData[i]);

            console.log("questions 360 1", this.questions360_1); 
            console.log("questions 360 2", this.questions360_2); 

            //graphic1
            let erData = [];
            this.EP.Values.forEach((x) => {
                //console.log(x);
                erData.unshift(x.Value);
            });

            this.EP.Values.forEach((x) => {
                //console.log(x);
                this.ERGraphicLabel.unshift(`                                   `); //Level ${ x.Level }
                this.levels1.unshift(x.Value);
            });


            this.ERGraphicDatasets = [
                {
                    data: erData,
                    label: "Energy Value"
                }
            ];


            //Graphic2
            let erpData = [];
            this.ESR.Values.forEach((x) => {
                //console.log(x);
                erpData.unshift(x.Value);
            });

            this.ESR.Values.forEach((x) => {
                //console.log(x);
                this.ERPGraphicLabel.unshift(`                                   `); //Level ${ x.Level }
                this.levels2.unshift(x.Value);
            });

            this.ERPGraphicDatasets = [
                {
                    data: erpData,
                    label: "Energy Value"
                }
            ];

            //Graphic 360 1 1


            this.finish = true;

        });
    }

    retriveChartData(array: any[]): Array<any> { //return array of arrays
        let questionsFormated = [];


        if (array != null) {
            array.forEach((item) => {
                //console.log(item);
                let temItem = [];
                temItem.push(item.Text);
                temItem.push([{ data: this.retriveValues(item.Answers) }]);
                temItem.push(this.retriveLabels(item.Answers));

                questionsFormated.push(temItem);

            });
            return questionsFormated;
        } else {
            this.show360Section = false;
        }

    }

    retriveValues(array: any[]): Array<any> {
        let valuesFormated = [];

        array.forEach((item) => {
            valuesFormated.push(item.Points); 
        });

        return valuesFormated;
    }

    retriveLabels(array: any[]): Array<any> {
        let labelsFormated = [];

        array.forEach((item) => {
            labelsFormated.push(item.RaterType);
        });

        return labelsFormated;
    }

    getAssessmentPageByUserType() {
        this.loading = true;
        this._AssessmentsService.getAssessmentPageByUserType(this.assessmentId, 3, this.language, 3).subscribe((data: any) => {
            console.log('response_getAssessmentPage', data);
            if (this._Globals.validationToken(data.result.Result)) {

                this.loading = false;

                let _data = JSON.parse(data.result.Data);
                console.log('_data', _data);
                this.content = _data.Content;
                
                $('#content').html(this.content);
                $('.ql-align-justify img').css('width', '100%');
            }
        });
    }


}
